module.exports = "/images/home.png?cd9cd22c0a505f19480616e3d4de9350";